// src/pages/GoalsPage.js
import React from "react";
import Account from "../components/Account/Account";
import NavBar from "../components/NavBar/NavBar";

export default function AccountPage() {
  return (
    <>
      <NavBar/>
      <main className="web-view">
        <Account/>
      </main>
    </>
  );
}